import React from 'react';
import * as Yup from 'yup';

import Input from 'components/Input';
import type { TFunction } from 'i18n/I18nContext';
import { useI18n } from 'i18n/I18nContext';

export interface AccountFormProps {
  errors?: Partial<Record<string, string>>;
  t?: TFunction;
  onGoogleClick?: () => void;
  googleEnabled?: boolean;
  googleLoading?: boolean;
}

const AccountForm = ({
  errors,
  t: tProp,
  onGoogleClick,
  googleEnabled = false,
  googleLoading = false,
}: AccountFormProps) => {
  const { t: tCtx } = useI18n();
  const t = tProp ?? tCtx;

  return (
    <div className="gb-onboard-step">
      <header className="gb-onboard-intro">
        <h1 className="gb-onboard-panel__title">{t('forms.signupTitle')}</h1>
        <ul className="gb-onboard-panel__lede">
          <li>{t('forms.signupBullet1')}</li>
          <li>{t('forms.signupBullet2')}</li>
          <li>{t('forms.signupBullet3')}</li>
        </ul>
      </header>

      {googleEnabled && onGoogleClick ? (
        <div className="gb-onboard-oauth">
          <button
            type="button"
            className="gb-onboard-oauth__google"
            onClick={onGoogleClick}
            disabled={googleLoading}
          >
            {googleLoading ? t('forms.googleContinueLoading') : t('forms.googleContinue')}
          </button>
          <p className="gb-onboard-oauth__divider">
            <span>{t('forms.orEmail')}</span>
          </p>
        </div>
      ) : null}

      <div className="gb-onboard-fields">
        <Input
          label={t('forms.fullName')}
          type="text"
          name="name"
          autoComplete="name"
          error={errors?.name}
        />

        <Input
          label={t('forms.email')}
          type="email"
          name="email"
          autoComplete="email"
          inputMode="email"
          error={errors?.email}
        />
      </div>
    </div>
  );
};

function validationSchema(_values: unknown, t: TFunction) {
  return Yup.object().shape({
    name: Yup.string().required(t('forms.valNameRequired')),
    email: Yup.string().required(t('forms.valEmailRequired')).email(t('forms.valEmailInvalid')),
  });
}

const AccountFormExport = AccountForm as typeof AccountForm & {
  validationSchema: typeof validationSchema;
};
AccountFormExport.validationSchema = validationSchema;

export default AccountFormExport;



// WEBPACK FOOTER //
// ./src/components/forms/AccountForm.tsx